// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as DateTime$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function parseDriverLocation($$location) {
  if ($$location !== undefined) {
    return $$location.lat + (", " + $$location.lng);
  } else {
    return "N/A";
  }
}

function getOtherInfoDisplayRecord(driverInfo) {
  return {
          hd: {
            label: "Last Updated Location",
            value: {
              TAG: /* Text */0,
              _0: parseDriverLocation(driverInfo.lastUpdatedLocation)
            }
          },
          tl: {
            hd: {
              label: "App Version",
              value: {
                TAG: /* Text */0,
                _0: String(OptionTypeUtils$Catalyst.getIntFrmOptionalType(driverInfo.appVersion))
              }
            },
            tl: {
              hd: {
                label: "Last Updated Location At",
                value: {
                  TAG: /* Text */0,
                  _0: DateTime$Catalyst.toString(undefined, OptionTypeUtils$Catalyst.getDateFrmOptionalType(driverInfo.lastLocationUpdatedAt))
                }
              },
              tl: {
                hd: {
                  label: "Cluster",
                  value: {
                    TAG: /* Text */0,
                    _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(driverInfo.clusterName)
                  }
                },
                tl: {
                  hd: {
                    label: "Date of Joining",
                    value: {
                      TAG: /* Text */0,
                      _0: DateTime$Catalyst.toString("DD-MM-YYYY", driverInfo.dateOfJoining)
                    }
                  },
                  tl: /* [] */0
                }
              }
            }
          }
        };
}

function getView(driverInfo) {
  return React.createElement(CardComponent$Catalyst.make, {
              title: "Other Info",
              className: "vehicle-info-container",
              children: React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                    loadableData: driverInfo,
                    children: (function (driverInfo) {
                        return CardRowViewMapper$Catalyst.CardRecordView.make("record", getOtherInfoDisplayRecord(driverInfo.driverProfile));
                      })
                  })
            });
}

export {
  parseDriverLocation ,
  getOtherInfoDisplayRecord ,
  getView ,
  
}
/* react Not a pure module */
